// react
import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePutApi,UsePostApi } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function SMTPForm() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, handleSubmit, setValue, errors, clearError, getValues } = useForm({ mode: "onChange" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 6000);
    };
    const endPoint = 'smtp/';

    const [smtpId, setsmtpId] = React.useState(0);
    useEffect(() => {
        LoadSMTPForm();
    }, []);

    const LoadSMTPForm = () => {
        const endPointGet = endPoint + "byestabelecimentoid/" + session.estabelecimentoId;
        UseGetApiSimple(endPointGet, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }

            setValue('enderecoSMTP', result.data.enderecoSMTP);
            setValue('porta', result.data.porta);
            setValue('senha', result.data.senha);
            setValue('emailEstabelecimento', result.data.emailEstabelecimento);
            setsmtpId(result.data.smtpId)
            return true;
        });
    }

    const [LoadingSaveForm, setLoadingSaveForm] = React.useState(false);

    const onSubmit = (data, e) => {
        e.preventDefault();

        if ((data.enderecoSMTP == "" || data.porta == "" || data.senha == "" || data.emailEstabelecimento == "")) {
            showNotification("Todos os campos devem ser preenchidos para cadastrar o SMTP!", 'warning');
            return;
        }

        let smtpPost = {
            smtp: smtpId != 0 ? smtpId : 0,
            estabelecimentoId: session.estabelecimentoId,
            enderecoSMTP: data.enderecoSMTP,
            porta: data.porta,
            senha: data.senha,
            emailEstabelecimento: data.emailEstabelecimento
        };

        setLoadingSaveForm(true);
        if (smtpId != 0) {
            let endPointPut = endPoint + "altersmtp/";
            UsePutApi(endPointPut,session.estabelecimentoId, smtpPost).then(result => {
                if (result.status !== 200) {
                    setLoadingSaveForm(false);
                    showNotification(result.message.mensagem, 'danger');
                    return false;
                }
                showNotification(result.message, 'success');
                setLoadingSaveForm(false);
                LoadSMTPForm();
                return true;
            });
        }
        else {
            UsePostApi(endPoint, smtpPost).then(result => {
                if (result.status !== 200) {
                    setLoadingSaveForm(false);
                    showNotification(result.message.mensagem, 'danger');
                    return false;
                }
                showNotification(result.message, 'success');
                setLoadingSaveForm(false);
                LoadSMTPForm();
                return true;

            });
        }
    }
    return (
        <div>
            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({ show: false })}
                close
            />
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12}>
                        <Card>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <div className="subTitulo">
                                            <h6>{t('label.data_smtp')} </h6>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                fullWidth
                                                label={t('label.address_smtp') + " *"}
                                                error={errors.nome ? true : false}
                                                variant="outlined"
                                                defaultValue=""
                                                name="enderecoSMTP"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: true })}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={2}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                fullWidth
                                                label={t('label.door_smtp') + " *"}
                                                error={errors.porta ? true : false}
                                                variant="outlined"
                                                defaultValue=""
                                                name="porta"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: true })}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={2}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                fullWidth
                                                label={t('login.password') + " *"}
                                                error={errors.senha ? true : false}
                                                variant="outlined"
                                                defaultValue=""
                                                name="senha"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: true })}
                                                type="password"
                                                InputProps={{
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Icon className={classes.inputAdornmentIcon}>
                                                        lock_outline
                                                    </Icon>
                                                    </InputAdornment>
                                                  ),
                                                  autoComplete: "off"
                                                }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                fullWidth
                                                label={t('label.account_name') + " *"}
                                                error={errors.nomeconta ? true : false}
                                                variant="outlined"
                                                defaultValue=""
                                                name="emailEstabelecimento"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: true })}
                                            />
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')} {LoadingSaveForm && <div> ... {t('label.loading')}</div>}
                        </Button>
                    </GridItem>
                </GridContainer>
            </form>

        </div >
    );
}